@if(this.operation){
    @if(this.isFetching){
        <div class="bloc_loading">
            <ion-spinner></ion-spinner>
        </div>
    }
    @else{
    
        <div id="header_additionals_datas">
            <marv-tag [color]="this.missionTypeService.getColor(operation.typeOfMissionCode)">{{operation.name}}</marv-tag>
            
            @if(this.lastModification !== null){
                <div id="last_modification">{{ 'DATE_LAST_MODIFICATION' | translate }} : <b>{{this.lastModification | marvDateToString: 'DD/MM/YYYY HH:mm'}}</b></div>
            }
            
        </div>        
    
        <form [formGroup]="this.additionalDataForm" (ngSubmit)="this.saveAdditionalsDatas()">
            <table>
                <tr>
                    <th></th>
                    <th>VR Coca cola</th>
                    <th>DP Coca Cola</th>
                    <th>VR Monster</th>
                    <th>DP Monster</th>
                </tr>
                <tr>
                    <th>Ligne de caisse</th>
                    <td><marv-input type="number" [min]="0" errorText="{{ 'MSG_NB_ADDITIONAL_DATA_ERROR' | translate }}" textAlign="center" formName="v_cash_register_vr_coca" [disabled]="!this.canEdit"/></td>
                    <td><marv-input type="number" [min]="0" errorText="{{ 'MSG_NB_ADDITIONAL_DATA_ERROR' | translate }}" textAlign="center" formName="v_cash_register_dp_coca" [disabled]="!this.canEdit"/></td>
                    <td><marv-input type="number" [min]="0" errorText="{{ 'MSG_NB_ADDITIONAL_DATA_ERROR' | translate }}" textAlign="center" formName="v_cash_register_vr_monster" [disabled]="!this.canEdit"/></td>
                    <td><marv-input type="number" [min]="0" errorText="{{ 'MSG_NB_ADDITIONAL_DATA_ERROR' | translate }}" textAlign="center" formName="v_cash_register_dp_monster" [disabled]="!this.canEdit"/></td>           
                </tr>       
                <tr>
                    <th>Zone Snacking</th>
                    <td><marv-input type="number" [min]="0" errorText="{{ 'MSG_NB_ADDITIONAL_DATA_ERROR' | translate }}" textAlign="center" formName="v_snack_vr_coca" [disabled]="!this.canEdit"/></td>
                    <td><marv-input type="number" [min]="0" errorText="{{ 'MSG_NB_ADDITIONAL_DATA_ERROR' | translate }}" textAlign="center" formName="v_snack_dp_coca" [disabled]="!this.canEdit"/></td>
                    <td><marv-input type="number" [min]="0" errorText="{{ 'MSG_NB_ADDITIONAL_DATA_ERROR' | translate }}" textAlign="center" formName="v_snack_vr_monster" [disabled]="!this.canEdit"/></td>
                    <td><marv-input type="number" [min]="0" errorText="{{ 'MSG_NB_ADDITIONAL_DATA_ERROR' | translate }}" textAlign="center" formName="v_snack_dp_monster" [disabled]="!this.canEdit"/></td>           
                </tr>
                <tr>
                    <th>Entrée Magasin</th>
                    <td><marv-input type="number" [min]="0" errorText="{{ 'MSG_NB_ADDITIONAL_DATA_ERROR' | translate }}" textAlign="center" formName="v_entrance_vr_coca" [disabled]="!this.canEdit"/></td>
                    <td><marv-input type="number" [min]="0" errorText="{{ 'MSG_NB_ADDITIONAL_DATA_ERROR' | translate }}" textAlign="center" formName="v_entrance_dp_coca" [disabled]="!this.canEdit"/></td>
                    <td><marv-input type="number" [min]="0" errorText="{{ 'MSG_NB_ADDITIONAL_DATA_ERROR' | translate }}" textAlign="center" formName="v_entrance_vr_monster" [disabled]="!this.canEdit"/></td>
                    <td><marv-input type="number" [min]="0" errorText="{{ 'MSG_NB_ADDITIONAL_DATA_ERROR' | translate }}" textAlign="center" formName="v_entrance_dp_monster" [disabled]="!this.canEdit"/></td>           
                </tr>
                <tr>
                    <th>Rayon boissons</th>
                    <td><marv-input type="number" [min]="0" errorText="{{ 'MSG_NB_ADDITIONAL_DATA_ERROR' | translate }}" textAlign="center" formName="v_shelf_vr_coca" [disabled]="!this.canEdit"/></td>
                    <td><marv-input type="number" [min]="0" errorText="{{ 'MSG_NB_ADDITIONAL_DATA_ERROR' | translate }}" textAlign="center" formName="v_shelf_dp_coca" [disabled]="!this.canEdit"/></td>
                    <td><marv-input type="number" [min]="0" errorText="{{ 'MSG_NB_ADDITIONAL_DATA_ERROR' | translate }}" textAlign="center" formName="v_shelf_vr_monster" [disabled]="!this.canEdit"/></td>
                    <td><marv-input type="number" [min]="0" errorText="{{ 'MSG_NB_ADDITIONAL_DATA_ERROR' | translate }}" textAlign="center" formName="v_shelf_dp_monster" [disabled]="!this.canEdit"/></td>           
                </tr>
                <tr>
                    <th>Surgelés</th>
                    <td><marv-input type="number" [min]="0" errorText="{{ 'MSG_NB_ADDITIONAL_DATA_ERROR' | translate }}" textAlign="center" formName="v_frozen_vr_coca" [disabled]="!this.canEdit"/></td>
                    <td><marv-input type="number" [min]="0" errorText="{{ 'MSG_NB_ADDITIONAL_DATA_ERROR' | translate }}" textAlign="center" formName="v_frozen_dp_coca" [disabled]="!this.canEdit"/></td>
                    <td><marv-input type="number" [min]="0" errorText="{{ 'MSG_NB_ADDITIONAL_DATA_ERROR' | translate }}" textAlign="center" formName="v_frozen_vr_monster" [disabled]="!this.canEdit"/></td>
                    <td><marv-input type="number" [min]="0" errorText="{{ 'MSG_NB_ADDITIONAL_DATA_ERROR' | translate }}" textAlign="center" formName="v_frozen_dp_monster" [disabled]="!this.canEdit"/></td>           
                </tr>
                <tr>
                    <th>Autres</th>
                    <td><marv-input type="number" [min]="0" errorText="{{ 'MSG_NB_ADDITIONAL_DATA_ERROR' | translate }}" textAlign="center" formName="v_others_vr_coca" [disabled]="!this.canEdit"/></td>
                    <td><marv-input type="number" [min]="0" errorText="{{ 'MSG_NB_ADDITIONAL_DATA_ERROR' | translate }}" textAlign="center" formName="v_others_dp_coca" [disabled]="!this.canEdit"/></td>
                    <td><marv-input type="number" [min]="0" errorText="{{ 'MSG_NB_ADDITIONAL_DATA_ERROR' | translate }}" textAlign="center" formName="v_others_vr_monster" [disabled]="!this.canEdit"/></td>
                    <td><marv-input type="number" [min]="0" errorText="{{ 'MSG_NB_ADDITIONAL_DATA_ERROR' | translate }}" textAlign="center" formName="v_others_dp_monster" [disabled]="!this.canEdit"/></td>           
                </tr>       
            </table>

            <marv-textarea 
                label="{{ 'COMMENTS' | translate }}" 
                icon="information-circle-outline" 
                formName="comments" 
                [fixedLabel]="true" 
                [withSpeechToText]="true"
                [disabled]="!this.canEdit"
                />

            @if(this.canEdit){
                <ion-grid>
                    <ion-row class="ion-justify-content-around">
                        <ion-col size="auto">
                            <marv-button type="submit" label="{{ 'SAVE' | translate }}" icon="checkmark-outline" color="primary" [isFetching]="this.isFetchingSave"/>
                        </ion-col>
                        <!--
                        <ion-col size="auto">
                            <marv-button type="button" label="{{ 'RESET' | translate }}" icon="refresh-outline" color="secondary" (click)="this.resetAdditionalsDatas()" />
                        </ion-col>
                        -->
                    </ion-row>
                </ion-grid>
            }
        </form>
    }
}

